// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__menuContainer___xyoHU {
    position: absolute;
    background-color: #ffffff;
    width: 300px;
    border: 0.5px solid lightgrey;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
}

.style__titleContainer___tUshS {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 24px;
    border-bottom: 0.5px solid lightgrey;

}

.style__name___XyVOy {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    max-width: 252px;
}


.style__fileSize___WTJAy {
    color: grey
}
`, "",{"version":3,"sources":["webpack://./src/components/ContextMenu/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;;AAExC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI;AACJ","sourcesContent":[".menuContainer {\n    position: absolute;\n    background-color: #ffffff;\n    width: 300px;\n    border: 0.5px solid lightgrey;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 12px;\n}\n\n.titleContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 8px 24px;\n    border-bottom: 0.5px solid lightgrey;\n\n}\n\n.name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-weight: bold;\n    max-width: 252px;\n}\n\n\n.fileSize {\n    color: grey\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `style__menuContainer___xyoHU`,
	"titleContainer": `style__titleContainer___tUshS`,
	"name": `style__name___XyVOy`,
	"fileSize": `style__fileSize___WTJAy`
};
export default ___CSS_LOADER_EXPORT___;
